<div mat-dialog-title>
	<h1>Payments Due For Enrollment #{{this.entityId}}</h1>
	<button mat-button mat-dialog-close>
			<mat-icon aria-hidden="false" aria-label="Close">close</mat-icon>
	</button>
</div>

<div [ngClass]="{
			'loading-shade': showProgressSpinner
	 }">

	<div mat-dialog-content>
		<app-enrollment-payments-due-view [enrollmentID]="this.entityId"></app-enrollment-payments-due-view>
	</div>
</div>
